import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YouTubeChannelBackupContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Intro */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        Backup an Entire YouTube Channel Instantly
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Download All Public Video Metadata as CSV
      </Typography>
      <Typography variant="body1" paragraph>
        Need to analyze a YouTube channel or archive its content for research, SEO, or planning? We've got you covered.
      </Typography>
      <Typography variant="body1" paragraph>
        Our YouTube Channel Backup tool fetches complete metadata (title, views, date, etc.) for every video in a channel. It's fast, reliable, and downloadable as a clean CSV.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use This Channel Backup Tool?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>📊 Instantly download a YouTube channel's public video data</li>
        <li>📁 Outputs a CSV file with views, titles, dates & more</li>
        <li>🔍 Great for competitor analysis, research, or archives</li>
        <li>🧠 No API key needed—just paste a video URL from the channel</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Backup a YouTube Channel
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Log in to MyFreshTools and open the Channel Backup tool.</li>
        <li>Paste any video URL from the YouTube channel you want to back up.</li>
        <li>Click “Download Channel Backup” to start processing.</li>
        <li>You’ll get a downloadable CSV containing full video metadata.</li>
      </ol>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>
      <Typography variant="body1" fontWeight="bold">🧠 Do I need to paste the channel URL?</Typography>
      <Typography variant="body2" paragraph>
        No. Just paste any video URL from the channel. We'll extract the channel automatically.
      </Typography>

      <Typography variant="body1" fontWeight="bold">🗂️ What data do I get?</Typography>
      <Typography variant="body2" paragraph>
        You'll get video titles, view counts, publish dates, durations, and more—ready to open in Excel or Google Sheets.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📉 Is this useful for analysis?</Typography>
      <Typography variant="body2" paragraph>
        Absolutely. This tool is perfect for understanding trends, tracking competitors, or building content plans.
      </Typography>

      <Typography variant="body1" fontWeight="bold">💰 Is this tool free?</Typography>
      <Typography variant="body2" paragraph>
        Free users get limited downloads. Upgrade your plan to unlock unlimited channel backups and extra features.
      </Typography>

      {/* CTA */}
      <Box mt={4}>
        <Button variant="contained" color="success" size="large" onClick={scrollToTop}>
          Start Your Channel Backup
        </Button>
      </Box>
    </Container>
  );
};

export default YouTubeChannelBackupContent;